import { InputBase, styled } from '@mui/material'
import { colorPalette } from '../../../style/colorPalette'

export const TextInput = styled(InputBase)({
  color: colorPalette.monotone[10],
  '&.Mui-focused': {
    backgroundColor: colorPalette.blue[0],
  },
})
